// 运营端路由
import Layout from '@/operationViews/Layout/index'

// 动态路由
const home = () => import('@/operationViews/views/home')
// 报备
const reporting = () => import('@/operationViews/views/reporting/index')
const appointmentList = () => import('@/operationViews/views/reporting/appointmentList')
const appointmentAdd = () => import('@/operationViews/views/reporting/appointmentAdd')
const appointmentHandle = () => import('@/operationViews/views/reporting/appointmentHandle')
const followList = () => import('@/operationViews/views/reporting/followList')
const followAdd = () => import('@/operationViews/views/reporting/followAdd')
const followRecord = () => import('@/operationViews/views/reporting/followRecord')
const remindList = () => import('@/operationViews/views/reporting/remindList')
// 入住
const checkinIndex = () => import('@/operationViews/views/checkin')
const checkinAdd = () => import('@/operationViews/views/checkin/add')

// 退住
const checkoutIndex = () => import('@/operationViews/views/checkout')
const checkoutAdd = () => import('@/operationViews/views/checkout/add')

// pdf
const pdf = () => import('@/operationViews/views/pdf/index')

const router = [
  {
    path: '/operation',
    name: 'operationHome',
    component: home,
    meta: {
      title: '首页'
    }
  },
  {
    path: '/reporting',
    name: 'reporting',
    component: Layout,
    children: [
      {
        path: '',
        name: 'reportIndex',
        meta: {
          title: '报备'
        },
        component: reporting
      },
      {
        path: '/appointmentAdd',
        name: 'appointmentAdd',
        meta: {
          title: '添加预约'
        },
        component: appointmentAdd
      },
      {
        path: '/appointmentList',
        name: 'appointmentList',
        meta: {
          title: '预约记录'
        },
        component: appointmentList
      },
      {
        path: '/appointmentHandle',
        name: 'appointmentHandle',
        meta: {
          title: '预约处理'
        },
        component: appointmentHandle
      },
      {
        path: '/followList',
        name: 'followList',
        meta: {
          title: '跟进拜访'
        },
        component: followList
      },
      {
        path: '/followAdd',
        name: 'followAdd',
        meta: {
          title: '新增拜访'
        },
        component: followAdd
      },
      {
        path: '/followRecord',
        name: 'followRecord',
        meta: {
          title: '拜访记录'
        },
        component: followRecord
      },
      {
        path: '/remindList',
        name: 'remindList',
        meta: {
          title: '工作提醒'
        },
        component: remindList
      }
    ]
  },
  {
    path: '/checkin',
    name: 'checkin',
    component: Layout,
    children: [
      {
        path: '',
        name: 'checkinIndex',
        meta: {
          title: '入住管理'
        },
        component: checkinIndex
      },
      {
        path: 'add',
        name: 'checkinAdd',
        meta: {
          title: '新增入住'
        },
        component: checkinAdd,
        beforeEnter: (to, from, next) => {
          console.log('to, from: ', to, from)
          // 根据自己业务判断
          to.meta.title = to.query.isWrite === 'true' ? '新增入住' : '查看入住信息'

          next()
        }
      }
    ]
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: Layout,
    children: [
      {
        path: '',
        name: 'checkoutIndex',
        meta: {
          title: '退住'
        },
        component: checkoutIndex
      },
      {
        path: 'add',
        name: 'checkinAdd',
        meta: {
          title: '申请退住'
        },
        component: checkoutAdd
      }
    ]
  },

  {
    path: '/pdf',
    name: 'pdf',
    component: Layout,
    children: [
      {
        path: '',
        name: 'pdfIndex',
        meta: {
          title: '预览'
        },
        component: pdf
      }
    ]
  }
]
export default router



// WEBPACK FOOTER //
// ./src/router/data/operation.js